import React, { useEffect, useState } from 'react';
import './AddExpenseModal.css'; // Unique CSS file

// ✅ VEHICLE LIST ADMIN API SE
import { useGetAllAssetsQuery, useGetAllLiteDevicesQuery } from '../../redux/admin/adminApi';

const AddExpenseModal = ({ onClose, onSubmit, initialData = {} }) => {
  const [formData, setFormData] = useState({
    vehicle: initialData?.vehicle || '',
    type: initialData?.type || '',
    description: initialData?.description || '',
    date: initialData?.date || '',
    amount: initialData?.amount || '',
    quantity: initialData?.quantity || '',
    paymentMode: initialData?.paymentMode || '',
    file: null,
  });

  // ✅ VEHICLES FETCH
  const { data: assetResponse, isLoading: isVehicleLoading } = useGetAllAssetsQuery();
  const { data: devicesResponse = [] } = useGetAllLiteDevicesQuery();

  const assets = Array.isArray(assetResponse)
    ? assetResponse
    : assetResponse?.assets || assetResponse?.data || [];
  const devices = Array.isArray(devicesResponse)
    ? devicesResponse
    : devicesResponse?.data || devicesResponse?.devices || [];
  const vehicles = (devices.length ? devices : assets).map((v) => ({
    _id: v._id,
    IMEI: v.imei || v.IMEI || '',
    model: v.model || '',
    name: v.name || '',
  }));

  useEffect(() => {
    setFormData({
      vehicle: initialData?.vehicle || '',
      type: initialData?.type || '',
      description: initialData?.description || '',
      date: initialData?.date || '',
      amount: initialData?.amount || '',
      quantity: initialData?.quantity || '',
      paymentMode: initialData?.paymentMode || '',
      file: null,
    });
  }, [initialData]);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFormData({ ...formData, file: e.target.files[0] });
    }
  };

  return (
    <div className="aem-modal-overlay">
      <div className="aem-modal-content">
        <div className="aem-modal-header">
          <h3>Add Expense</h3>
          <button className="aem-close-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="aem-modal-body">

          {/* ✅ ROW 1 */}
          <div className="aem-form-grid-3">

            {/* ✅ VEHICLE SELECT (LIKE TRIP) */}
            <div className="aem-form-group">
              <label>Vehicle *</label>
              <select
                name="vehicle"
                className="aem-form-control"
                value={formData.vehicle || ''}
                onChange={handleChange}
              >
                <option value="">-- Select Vehicle --</option>
                {isVehicleLoading ? (
                  <option>Loading vehicles...</option>
                ) : (
                  vehicles.map((v) => (
                    <option key={v._id} value={v._id}>
                      {v.model || "Vehicle"} ({v.IMEI})
                    </option>
                  ))
                )}
              </select>
            </div>

            {/* ✅ TYPE DROPDOWN */}
            <div className="aem-form-group">
              <label>Type *</label>
              <select name="type" className="aem-form-control" value={formData.type || ''} onChange={handleChange}>
                <option value="">Select Type</option>
                <option value="Fuel">Fuel</option>
                <option value="Food">Food</option>
                <option value="Service">Service</option>
                <option value="Tools">Tools</option>
                <option value="Parts">Parts</option>
                <option value="Hotel">Hotel</option>
                <option value="Toll">Toll</option>
                <option value="Other">Other</option>
              </select>
            </div>

            {/* ✅ DESCRIPTION */}
            <div className="aem-form-group">
              <label>Description</label>
              <input
                type="text"
                name="description"
                className="aem-form-control"
                value={formData.description || ''}
                onChange={handleChange}
                placeholder="Expense details"
              />
            </div>

          </div>

          {/* ✅ ROW 2 */}
          <div className="aem-form-grid-3">

            <div className="aem-form-group">
              <label>Date *</label>
              <input
                type="date"
                name="date"
                className="aem-form-control"
                value={formData.date || ''}
                onChange={handleChange}
              />
            </div>

            <div className="aem-form-group">
              <label>Amount *</label>
              <input
                type="number"
                name="amount"
                className="aem-form-control"
                value={formData.amount || ''}
                onChange={handleChange}
                placeholder="0.00"
              />
            </div>

            <div className="aem-form-group">
              <label>Quantity</label>
              <input
                type="number"
                name="quantity"
                className="aem-form-control"
                value={formData.quantity || ''}
                onChange={handleChange}
                placeholder="e.g. Liters"
              />
            </div>

          </div>

          {/* ✅ ROW 3 */}
          <div className="aem-form-grid-2">

            {/* ✅ FILE UPLOAD */}
            <div className="aem-form-group">
              <label>Receipt Upload</label>
              <div className="aem-file-input-wrapper">
                <input
                  type="file"
                  id="aem-exp-upload"
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                />
                <label htmlFor="aem-exp-upload" className="aem-file-label-btn">
                  Choose File
                </label>
                <span className="aem-file-text">
                  {formData.file ? formData.file.name : "No file chosen"}
                </span>
              </div>
            </div>

            {/* ✅ PAYMENT MODE */}
            <div className="aem-form-group">
              <label>Mode of Payment</label>
              <select
                name="paymentMode"
                className="aem-form-control"
                value={formData.paymentMode || ''}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                <option value="Online">Online</option>
              </select>
            </div>

          </div>

        </div>

        {/* ✅ FOOTER */}
        <div className="aem-modal-footer">
          <button className="aem-btn-submit" onClick={() => onSubmit(formData)}>
            SUBMIT
          </button>
          <button className="aem-btn-cancel" onClick={onClose}>
            CANCEL
          </button>
        </div>

      </div>
    </div>
  );
};

export default AddExpenseModal;
